import { createBrowserHistory, createMemoryHistory }  from 'history';
const BrowserHistory = createBrowserHistory();
let popUtilPathnameArr: [string, string] | null = null;

const VirtualHistory = createMemoryHistory({
  initialEntries: [BrowserHistory.location.pathname]
});

let hasChangeRoute = false;

BrowserHistory.listen(function(location, action) {
  (() => { // 同步VirtualHistory
    const program = {
      PUSH: () => {
        VirtualHistory.push(location)
      },
      POP: () => {
        const lastPathname = VirtualHistory.location.pathname;
        const index = VirtualHistory.entries.findIndex(_location => _location.pathname === location.pathname);
        const offset = index - VirtualHistory.index;
        
        VirtualHistory.go(offset);
        if(offset === 0 && !popUtilPathnameArr) {
          BrowserHistory.go(-1);
        }

        if (popUtilPathnameArr) {
          console.log('popUtilPathnameArr', popUtilPathnameArr);
          console.log('lastPathname', lastPathname);
          console.log('location.pathname', location.pathname);
          if (lastPathname.replace('/cube', '') === popUtilPathnameArr[0]) {
            const popIndex = VirtualHistory.entries.findIndex(_location => _location.pathname.replace('/cube', '') === popUtilPathnameArr[1]);
            console.log('popIndex', popIndex);
            popUtilPathnameArr = null;
            if (popIndex >= 0) {
              const offset = popIndex - index;
              console.log('offset', offset);
              if(offset < 0) {
                setTimeout(() => {
                  BrowserHistory.go(offset);
                }, 100);
              }
            }
          }
        }
      },
      REPLACE: () => {
        VirtualHistory.replace(location)
      }
    }
    program[action]()
  })()

  // 由于首次加载时，BrowserHistory.action为'POP'，因此若第一个页面调用isGoBack会得到true的结果
  // 为了避免该情况，加入该变量，标记有改变过路由且action为'POP'时才是真正的返回
  hasChangeRoute = true;
});

export function isGoBack(): boolean {
  return hasChangeRoute && BrowserHistory.action === 'POP';
}

export const canGo = (n: number): boolean => {
  return VirtualHistory.canGo(n)
}

// 返回至指定页面，再打开新页面
export const pushAndPopUntil = (targetUrl: string, pathnameArr: [string, string]) => {
  popUtilPathnameArr = pathnameArr;
  targetUrl && BrowserHistory.push(targetUrl);
}

export default BrowserHistory

